var config = function () {

}

// 测试服
// config.serverBaseUrl = "http://dict-listening.inner.youdao.com";
config.serverlisteningBaseUrl = 'http://listening-editor.inner.youdao.com/'
// config.serverAchievementBaseUrl = 'http://zj176x.corp.youdao.com:11193/'
// 正式服：
config.serverBaseUrl = "http://dict.youdao.com";
config.serverAchievementBaseUrl = 'http://listening-act.youdao.com/'
export default config;